// Excel de auditoría de un LOTE de extras: qué se subió exactamente (una fila por
// extra aplicado) y la metadata del lote (archivo, quién lo subió, cuándo, totales).
// A diferencia de la planilla banco, este archivo no lo importa nadie: es para que el
// operador pueda revisar/archivar la carga fuera del portal, así que prima la lectura.
import { utils, writeFile } from 'xlsx';

const ITEM_HEADERS = ['Repartidor', 'Fecha', 'Monto', 'Motivo'];
const ITEM_COL_WIDTHS = [32, 12, 12, 40];
const META_COL_WIDTHS = [22, 44];

const money = (v) => Math.round(Number(v) || 0);

// Nombre del archivo descargado: conserva el nombre original del Excel subido (sin
// extensión) para que el operador lo reconozca; cae al batchId corto si no lo hay.
export const extrasBatchFilename = (batch) => {
  const base = String(batch?.filename ?? '')
    .replace(/\.[^.]+$/, '')
    .trim() || String(batch?.batchId ?? 'lote').slice(0, 8);
  const date = batch?.createdAt
    ? new Date(batch.createdAt).toISOString().slice(0, 10)
    : '';
  return `lote-extras-${base}${date ? `-${date}` : ''}.xlsx`;
};

/**
 * Genera y descarga el .xlsx del lote. `batch` e `items` vienen del endpoint
 * extras-batch/:batchId/items; `t` para los rótulos.
 */
export const downloadExtrasBatchSheet = ({ batch, items, t }) => {
  const wb = utils.book_new();

  // Hoja 1 — "Extras": las filas tal como quedaron aplicadas, con fila de total.
  const rows = (items ?? []).map((it) => [
    it.driverName || it.driverId,
    it.date,
    money(it.amount),
    it.description ?? '',
  ]);
  const total = (items ?? []).reduce((s, it) => s + money(it.amount), 0);
  const itemsSheet = utils.aoa_to_sheet([
    ITEM_HEADERS.map((h) => t(h)),
    ...rows,
    [t('Total'), '', total, ''],
  ]);
  itemsSheet['!cols'] = ITEM_COL_WIDTHS.map((wch) => ({ wch }));
  utils.book_append_sheet(wb, itemsSheet, t('Extras'));

  // Hoja 2 — "Lote": metadata de auditoría (quién, cuándo, cuánto).
  const fmtDateTime = (v) => (v ? new Date(v).toLocaleString() : '');
  const meta = [
    [t('Archivo'), batch?.filename ?? ''],
    [t('Subido por'), batch?.uploadedByName ?? ''],
    [t('Fecha de subida'), fmtDateTime(batch?.createdAt)],
    [t('Extras aplicados'), batch?.appliedCount ?? rows.length],
    [t('Monto total'), money(batch?.totalAmount ?? total)],
    [
      t('Estado'),
      batch?.status === 'rolled_back' ? t('Revertido') : t('Aplicado'),
    ],
  ];
  if (batch?.status === 'rolled_back') {
    meta.push(
      [t('Revertido por'), batch?.rolledBackByName ?? ''],
      [t('Fecha de reversión'), fmtDateTime(batch?.rolledBackAt)],
    );
  }
  const metaSheet = utils.aoa_to_sheet(meta);
  metaSheet['!cols'] = META_COL_WIDTHS.map((wch) => ({ wch }));
  utils.book_append_sheet(wb, metaSheet, t('Lote'));

  writeFile(wb, extrasBatchFilename(batch));
};
